import { QueryKey } from '@tanstack/react-query'
import {
  TExpandedAvailabilityRecipe,
  TRecipeAvailability,
} from '@mindfulchefuk/types/recipeAvailabilities'
import { transformRecipeAvailbilityExpandedData } from '@mindfulchefuk/helpers/dataTransforms/transformRecipeAvailabilitiesData'

export const fetcherGetRecipeAvailabilityById = async ({
  queryKey,
}: {
  queryKey: QueryKey
}): Promise<TRecipeAvailability<TExpandedAvailabilityRecipe>> => {
  const [, { id }] = queryKey as [string, { id: string }]

  const result = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/v2/recipe_availabilities/${id}`,
    {
      method: 'GET',
      referrerPolicy: 'strict-origin-when-cross-origin',
    }
  ).then((response) => response.json())

  const transformed = transformRecipeAvailbilityExpandedData(
    result.recipe_availability
  )

  return transformed
}
